import * as React from 'react'

import { RadioInput } from './styles'

interface IProps {
  checked: boolean
  disabled: boolean
  invalid: boolean
  onChange: (checked: boolean) => void
}

export default function Radio(props: IProps) {
  const { checked, disabled, invalid, onChange } = props

  return (
    <RadioInput
      type="radio"
      checked={checked}
      disabled={disabled}
      invalid={invalid}
      onChange={event => onChange(event.target.checked)}
    />
  )
}

Radio.defaultProps = {
  disabled: false,
  invalid: false,
}
